export default __webpack_public_path__ + "static/media/chevron-down.905c59c9.svg";